import React, {useEffect, useState} from "react";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import PageTitle from "../../../Utils/smsTitle";
import {SubHeader} from "../../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import {connect} from "react-redux";

import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import {sentenceCase, titleCase} from "../../../Users/addUser";
import {useTheme} from "@material-ui/core/styles";
import {ResizableTextarea} from "../../../Utils/FormInputs/Textarea";
import {RightAlignedContainer} from "../../../Utils/styledComponents";
import * as colors from "../../../../styles/colors";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Label, {FormLabel, ToolTip} from "../../../Utils/FormInputs/Label";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";

const GynAndObsDiagnosis = ({actions, snackbars,match}) => {
    const {patient_number, visit_id, patient_type} = match.params;
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;

    const storage = JSON.parse(sessionStorage.getItem('diagnosis'))
    const item = storage ? storage : {}
    const note_item = item[visit_id] ? item[visit_id] : ''
    const diagNotes = () => note_item || ''
    const [state, setState] = useState({ notes:diagNotes(), date:'', isDisabled:false, diagnosis_id:''});
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [allCodes, setAllCodes] = useState([]);
    const [codes, setCodes] = useState([]);
    const [status, setStatus] = useState('disease');
    const [submitted, setSubmitted] = useState(false);
    const [showDiagnosis, setShowDiagnosis] = useState(false);
    const [disease, setDisease] = useState('');
    const [notesStatus, setNotesStatus] = useState('idle')
    const [error, setError] = useState(null);
    const [previousDiagnosis, setPreviousDiagnosis] = useState([]);
    const [isDiagnosis, setIsDiagnosis] = useState('')
    const [diagnosisRemoved, setDiagnosisRemoved] = useState([])
    const [isNew, setIsNew] = useState(false)

    const isResolved = isSubmitted === 'resolved'
    const isSuccess = notesStatus === 'success'
    useEffect(() => {
        if(isSuccess){
            return
        }
        const formData = new FormData();
        formData.append('visit_id', visit_id)
        axios.post(`${config.smsUrl}/cdoctor/get_previous_diagnosis`, formData).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const items = dt.diagnosis ? dt.diagnosis : []
            const id = items[items.length - 1] ? items[items.length - 1] : {};
            const note = id.diagnosis_id ? id.diagnosis_id : '';
            setPreviousDiagnosis(items);
            setIsDiagnosis(note)
        }).catch(error => {
            logoutErrorMessage(error, null, actions)
        });
    }, [isResolved, notesStatus])


    useEffect(() => {
        if(!(isDiagnosis && previousDiagnosis)){
            return;
        }
        const arr = previousDiagnosis.map(item => ({
            ...item, isAdded:false
        }))
        const diag_codes = arr.filter(item=>item.diagnosis_code || item.diagnosis).map(item=>({
            code:item.diagnosis_code, ...item
        }))
        const prevNotes = arr.filter(item=>item.notes).map(item => ({notes:item.notes, diagnosis_id:item.diagnosis_id}));

        const newArr = [...new Set(prevNotes)];
        const notesArr = newArr.filter(item=>Boolean(item))
        const diagnosis = notesArr ? notesArr : [];

        const id = diagnosis[notesArr.length - 1] ? diagnosis[notesArr.length - 1] : {};

        const note = id.notes ? id.notes : '';
        const diagnosis_id = id.diagnosis_id ? id.diagnosis_id : '';

        setState({...state, notes:note, isDisabled: (note !== '' || diag_codes.length > 0), diagnosis_id})
        setCodes(diag_codes)
    }, [isDiagnosis, previousDiagnosis]);


    const handleChangeState = (event) => {
        const {name, value} = event.target;
        setState({...state, [name]: value})
        const obj = {[visit_id]: value}
        sessionStorage.setItem('diagnosis', JSON.stringify({...item, ...obj}))
        setIsSubmitted('idle')
    };

    const handleChangeStatus = (event) => {
        setStatus(event.target.value)
        setDisease('')
        setShowDiagnosis(false)
    }

    const stripString = (str) => {
        let arr = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        return arr ? titleCase(arr) : arr
    }


    const handleCreateNewDisease = () =>{
        setIsNew(true)
        setShowDiagnosis(false)
    }

    const retrieveAllCodes = (event) => {
        const {value} = event.target
        setDisease(event.target.value)
        if (event.target.value !== '' && !isNew) {
            const formData = new FormData();
            formData.append('code', status === 'code' ? value.toUpperCase() : '');
            formData.append('diagnosis', status === 'disease' ? sentenceCase(value) : '');
            axios.post(`${config.smsUrl}/cdoctor/auto_search_codes`, formData).then(res => {
                const data = res.data;
                const dt = !data ? [] : data;
                if (dt.length > 0) {
                    setAllCodes(dt);
                } else {
                    setAllCodes([{code: '', diagnosis:`No results found for ${value}`}])
                }

            }).catch(error => {
                logoutErrorMessage(error, null, actions)
            });
            setShowDiagnosis(true)
        } else {
            setShowDiagnosis(false)
        }
        setIsSubmitted('idle')
    };

    const getDetails = (event) => {
        const formData = new FormData();
        formData.append('code', status === 'code' ? event.value : '');
        formData.append('diagnosis', status === 'disease' ? event.innerText : '');
        if (event.value || event.innerText) {
            axios.post(`${config.smsUrl}/cdoctor/retrieve_icd_info`, formData).then(res => {
                const resp = res.data;
                let data = !resp ? {} : resp;
                data['code'] = event.value
                data['isAdded'] = true
                setCodes([...codes, data])
                setDisease('')
            }).catch(error => {
                logoutErrorMessage(error, null, actions)
            });
            setError(null)
        } else {
            setError('Please enter a valid disease or code')
        }
        setShowDiagnosis(false)

    };

    const handleAddNewDiagnosis = () =>{
        const obj = {code:'', diagnosis:disease, isAdded:true}
        setCodes([...codes, obj])
        setIsNew(false)
        setDisease('')
    }

    const cancelNewDiagnosis = () =>{
        setIsNew(false)
        setDisease('')
    }

    const removeRow = (idx) => {
        const arr = codes.filter((item, index ) => index !== idx)
        const removed =  codes.filter((item, index) => index === idx)
        setCodes(arr);
        setDiagnosisRemoved([...diagnosisRemoved,...removed])
    };

    const handleSubmitNotes = (event) => {
        event.preventDefault();

        // get the notes and their diagnosis id
        const {notes, diagnosis_id} = state;

        // get the icd codes
        // get the ones with the valid code and diagnosis
        const filteredArr = codes.filter(item => item.diagnosis && item.code);
        // confirm that some items in filteredArr has an id
        const check_codes = filteredArr.some(item => item.diagnosis_id);

        const newDiseases = codes.filter(item=>item.code === '')

        // check if there were already existing data for the notes and codes
        const params = (diagnosis_id || check_codes) ? {
            notes_diagnosis_object: {
                diagnosis_id,
                notes
            },
            visit_id,
            diagnosis: [...filteredArr, ...newDiseases].filter(item=>!item.isAdded).map(({isAdded,...item })=>item),
            // disease:newDiseases,
            new_diagnosis:  [...filteredArr, ...newDiseases].filter(item=>item.isAdded).map(({isAdded, ...item})=>({...item})),
            removed_diagnosis: diagnosisRemoved.map(({isAdded, ...item})=>({...item})).filter(item=>item.diagnosis_id)
        } : {
            visit_id,
            notes,
            diagnosis: [...filteredArr, ...newDiseases].map(({isAdded,...item })=>item),
            // disease:newDiseases
        };

        setSubmitted(true);
        if (notes && codes.length > 0) {
            setIsSubmitted('pending');
            const url = (diagnosis_id || check_codes) ? 'update_diagnosis': 'save_diagnosis';
            axios.post(`${config.smsUrl}/cdoctor/${url}`, params ).then(() => {
                actions.snackbarActions.snackSuccess(`Diagnosis ${(diagnosis_id || check_codes) ? 'updated': 'saved'} successfully`)
                setIsSubmitted('resolved');
                setCodes([]);
                setSubmitted(false)
                setNotesStatus('idle')
                setDisease('')
            }).catch(err => {
                setIsSubmitted('rejected');
                errorMessages(err, null, actions)
            })
        }
    };

    const handleContinue = () =>{
        setState({...state, isDisabled:false})
        setNotesStatus('success')
    }



    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

    const {notes, isDisabled} = state;
    const theme = useTheme();
    const them = !theme ? {} : theme;
    const palette = !them.palette ? {} : them.palette;
    const val = status === 'disease' ? disease :   disease.toUpperCase();
    const isDisease = status === 'disease';
    const is_codes = codes.filter(item => item.diagnosis && item.code);
    const isMissingDisease = allCodes.filter(item=>item.code === '')
    const newDiagnosis = (
        <div className='mt-2'>
            <ResizableTextarea value={disease} rows={2} onChange={retrieveAllCodes}/>
            <RightAlignedContainer>
                <button type='button' onClick={handleAddNewDiagnosis} className='btn btn-sm small-btn sms-info-btn mr-2 mt-2'>Add</button>
                <button type='button' onClick={cancelNewDiagnosis} className='btn btn-sm small-btn sms-gray-btn mr-2 mt-2'>Cancel</button>
            </RightAlignedContainer>
        </div>
    )

    const newDisease = (
        <ul>
            {allCodes.map((val, idx) => {
                const missingDisease = (
                    <p style={{margin:'0.65rem 0'}}>No results found for <strong>{`"${disease}"`}</strong>
                        <span data-testid='missing-disease' style={{display:'inline-block', textDecoration:'underline', color:colors.blue, marginLeft:'5px'}}>Create {disease}</span></p>
                )
                return(
                    <li style={{listStyle:'none'}} key={idx} value={val.code} className="drug-li"
                        data-testid="lab-tests"
                        onClick={handleCreateNewDisease}>{missingDisease}</li>

                )})}
        </ul>
    )



    const {openBar, type, message} = snackbars;
    return (
        <div className='journals'>
            <PageTitle title="Diagnosis"/>
            <SubHeader
                title="Doctor"
                subTitle="Diagnosis"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <MainSnackbar open={openBar} handleCloseBar={closeSnackbar} variant={type} message={message}/>
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                <form autoComplete="off" onSubmit={handleSubmitNotes} className='mt-2'>
                    {(submitted && !(notes || disease)) &&
                        <div className="alert alert-danger text-center">Please enter notes or diagnosis to
                            proceed</div>}
                    <div className="patient-triage mt-1">
                        <div className="row">
                            <div className="col-md-10 searchable">
                                <Form.Group as={Row}>
                                    <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                        <Label name="Search by:"/>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                        <Form.Check inline value="disease" onChange={handleChangeStatus}
                                                    name="status" label="Disease" type="radio"
                                                    checked={status === 'disease'} className="form__label"/>
                                        <Form.Check inline value="code" onChange={handleChangeStatus}
                                                    name="status" label="ICD code" type="radio"
                                                    className="form__label"/>
                                    </Col>
                                    <Col xs={11} sm={11} md={11} lg={5} xl={5}>
                                        {isNew ? newDiagnosis : <>
                                            <Form.Control value={disease ? val : ''} type="text" disabled={isDisabled}
                                                          name="disease_name" data-testid="disease_name"
                                                          className={`form__control  ${palette.type === "dark" && 'form-control-dark'}`}
                                                          onChange={retrieveAllCodes}
                                                          placeholder={`${status === 'disease' ? 'Enter keyword' : 'Enter ICD Code'}`}/>
                                            {error && <div
                                                className="help-block">{`Please enter a valid ${status === 'disease' ? 'keyword' : 'code'}`}</div>}
                                        </>}
                                        {showDiagnosis &&
                                            <>
                                                {isMissingDisease.length > 0 ?
                                                    newDisease
                                                    :
                                                    <Form.Control as="select" className="drug-ul diagnosis-ul" multiple
                                                                  data-testid="disease-list">
                                                        {allCodes.map((val, idx) => {
                                                            return (
                                                                <option key={idx} value={val.code} className="drug-li"
                                                                        data-testid={`disease-item-${idx}`}
                                                                        onClick={() => getDetails({
                                                                            value: val.code,
                                                                            innerText: val.diagnosis
                                                                        })}>{`${val.code} - ${titleCase(val.diagnosis)}`}</option>
                                                            )
                                                        })}
                                                    </Form.Control>
                                                }
                                            </>}

                                    </Col>
                                    {!isNew ? <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <ToolTip
                                            toolTip={isDisease ? 'Enter disease name according to the ICD Standard' : 'Enter ICD code'}/>
                                    </Col> : null}

                                </Form.Group>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className={`table table-sm table-bordered billing-invoice-table procedure-table ${palette.type === 'dark' &&
                                'dark-table dark-table-bordered'}`}>
                                <thead>
                                <th className={palette.type === 'dark' && 'dark-theme-color'}>Disease</th>
                                <th className={palette.type === 'dark' && 'dark-theme-color'}>ICD code</th>
                                <th width="80px">Action</th>
                                </thead>
                                <tbody>
                                {codes.filter(item => item.diagnosis).map((test, indx) => (
                                    <tr key={indx}>
                                        <td>{test.diagnosis}</td>
                                        <td className={palette.type === 'dark' && 'dark-theme-color'}>{test.code}</td>
                                        <td>
                                            <div className="btn-group">
                                                {!isDisabled
                                                    ?
                                                    <button onClick={() => removeRow(indx)} type="button"
                                                            className="btn btn-sm sms-btn-dismiss"
                                                            data-testid="remove-test-name">
                                                        <FontAwesomeIcon icon={faTrash}/>
                                                    </button>
                                                    : null
                                                }

                                            </div>
                                        </td>
                                    </tr>
                                ))}

                                </tbody>
                            </table>
                        </div>
                        <Form.Group>
                            <FormLabel className="pl-0" name='Diagnosis Notes' htmlFor='diagnosis_notes' isRequired
                                       toolTip='Capture additional diagnosis notes here'/>
                            <ResizableTextarea value={notes} name="notes"
                                               onChange={handleChangeState} disabled={isDisabled}
                                               id="diagnosis_notes"
                            />
                        </Form.Group>
                    </div>
                    {(notes || (is_codes.length > 0)) && isDisabled ? <>
                            <button type="button" className="btn sms-info-btn mt-2 ml-3" onClick={handleContinue}>Continue
                            </button>
                            {/*<button type="button" onClick={handleReset}
                        className="btn sms-btn mt-2 ml-3"> Add New Notes</button>*/}</> :
                        <button type="submit" disabled={isSubmitted === 'pending'}
                                className="btn sms-btn mt-2 ml-3">{isSubmitted === 'pending' ? "Saving" : "Save Notes"}</button>
                    }
                </form>
            </ObGynSidebar>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(GynAndObsDiagnosis);